module.exports = __webpack_public_path__ + "img/card-side2.9c6af5bb.png";